import React from 'react';
//import PropTypes from 'prop-types';
import {Button} from 'react-md';

//Local Imports
import { AppProperties } from '../common/functions';

//Import CSS
import '../css/Login.css';
import LoadingSpinner from './LoadingSpinner';



class Login extends React.Component {

    appProperties = AppProperties();

    constructor(props) {
      super();

      this.state = {
        loading: false,
      }
    }

    login()
    {
      this.setState({loading : true});
      let responsePromise = this.props.apiService({method: 'post',
      url: '/Login',
      data: null});
        responsePromise.then(res => {
            console.log(res);
            this.setState({loading : true});
            this.appProperties.currentUserData.setUserDetails(res.data);
            window.location.reload();
        }).catch(error => {
          console.error("Error when getting Quiz",error)
        });
    }

    render() {

        if (this.state.loading) {
          return <LoadingSpinner />;
        }
        else{

        return        <div className="login-container">
        <br/><br/><br/>
          <h2>Welcome to essential Skills!</h2><br/>
          <h3>Here’s what to do next:</h3><br/><br/>
          <p>1. First sign in to your specific section in your class. Do this through the settings link. You may
          edit the settings at any time.</p>
          <p>2. To see your assignments, access your dashboard via the “dashboard” link on the left (or in the
          menu button on the mobile).</p><br/><br/>
          <Button primary raised onClick={this.login.bind(this)} >Login</Button>
          </div>
        }

    }
  }

  export default Login;
